import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { SaveHseWeeklyReportRequest } from '../types/hse-weekly-report.type';

export const getHseWeeklyReport = (
  organizationId: string,
  siteId: string,
  weekStart: string,
) =>
  makeRequest({
    url: `/dashboard/organization/${organizationId}/collection_site/${siteId}/hse-weekly`,
    method: HttpMethods.GET,
    params: { week_start: weekStart },
  });

export const saveHseWeeklyReport = (
  organizationId: string,
  siteId: string,
  weekStart: string,
  body: SaveHseWeeklyReportRequest,
) =>
  makeRequest({
    url: `/dashboard/organization/${organizationId}/collection_site/${siteId}/hse-weekly`,
    method: HttpMethods.PATCH,
    params: { week_start: weekStart },
    data: body,
  });
